// extracted by mini-css-extract-plugin
module.exports = {"container":"_3X2YG","hero-container":"_3L2QH","hero-title":"_3iRsy","hero-img":"_24xUM","img-container":"ozt34","title":"d-Y_f","list":"YLc_G","list-item":"_3KUil"};